import m from "moment-jalaali"
import * as momentRange from "moment-range"

const getMoment = () => (
  momentRange.extendMoment(m)
)

export default getMoment